import React from 'react';
import { domain } from '../../common/config.js';
import './css/shared-replayer.css'
import ReplayHand from '../HandReplayer/ReplayHand.js';
import HandReplayer from '../HandReplayer/HandReplayer.js';
import Header from '../../container/Header/Header.js';
import { apiService } from '../../common/apiCallService.js'
import { baseUrl } from '../../common/config.js'
import queryString from 'query-string';
import Media from 'react-media';
import { getImage } from '../../common/ThemeService.js';
import i18next from 'i18next'
let CarepetBackground = "//"+domain+"/images/handReplay/PartyPoker/table_carpet.jpg";

export default class SharedReplayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginStatus: localStorage.getItem('token') ? true : false,
      gameType: '',
      gameNo : '',
      playerAlias: '',
      partitionDate: '',
      sharedType:'',
      sharedId:'',
      slideIndex:'',
      selectedHandList: [],
      isMultipleHands: false,
      displayContent: true,
      currentReplayerHandIndex: 0,
      loggedInType:'PartyPoker'
    }
  }

  componentDidMount() {
    if (localStorage.getItem("loggedInType") === "Danskespil") {
      CarepetBackground = "//" + domain + "/images/handReplay/Danskespil/table_carpet.jpg";
    }
    const { id } = queryString.parse(this.props.location.search);    
    apiService(baseUrl + '/shareLinkMetadata/findById',
      { id },
      (data) => {
        // console.log(data)
        const {
          attribute1: gameType, 
          attribute2: gameNo, 
          attribute3: playerAlias,
          attribute4: partitionDate,
          attribute5: slideIndex,
          _id : sharedId,
          attribute6
        } = data;

        const loggedInType= attribute6 || 'PartyPoker';
        if (gameNo.includes("[")) {
          this.setState({ isMultipleHands: true, currentReplayerHandIndex: 0, selectedHandList: JSON.parse(gameNo) });
        }
        this.setState({
          gameType, 
          gameNo, 
          playerAlias,
          partitionDate,
          sharedId,
          slideIndex,
          loggedInType 
        })
      }, (err) => {
        console.log(err);
      })
  }

  styles = {
    navContent: {
      color: "white",
      padding: "8px 20px",
      borderRadius: "4%",
      fontWeight: "700"
    }
  }

  prevHand = () => {
    if (this.state.currentReplayerHandIndex > 0) {
      this.setState({ displayContent: false }, () => {
        this.setState({ currentReplayerHandIndex: this.state.currentReplayerHandIndex - 1, displayContent: true })
      })
    }
  }
  nextHand = () => {
    if (this.state.currentReplayerHandIndex < this.state.selectedHandList.length - 1) {
      this.setState({ displayContent: false }, () => {
        this.setState({ currentReplayerHandIndex: this.state.currentReplayerHandIndex + 1, displayContent: true })
      })
    }
  }
  openThisHand = (currentReplayerHandIndex) => {
    this.setState({ displayContent: false }, () => {
      this.setState({ currentReplayerHandIndex, displayContent: true })
    })
  }

  ShareHeader = (props) => {
    const logo = getImage("/images/logo/", ".png")
    const PartyPokerIcon = `https:${domain}${logo}`
  return (
    props.loginStatus ? <Header /> :
      <div>
        <nav className="headerBar navbar-fixed-top" >
          <div className='container'>
            <div className="navbar-collapse" style={{ margin: 0 }}>
                <img src={`/images/logo/${this.state.loggedInType}.png`} style={{float:"left", width: '12em', paddingTop:"5px", paddingBottom: "5px" }} />
              <div style={{ float: 'right' }}>
                <a style={{ ...this.styles.navContent, marginRight: "15px" }} href='/'>Log In</a>
                <a style={{ ...this.styles.navContent, backgroundColor: 'rgb(235, 96, 46)', marginLeft: '15px' }} href='https://poker.partypoker.com/en/my-game?_nocache=1&_mode=preview'>Learn More</a>
              </div>
            </div>
          </div>
        </nav>
      </div>
  )}
  render() {
    const { loginStatus } = this.state;
    let fullVersion = 0
    console.log("navigator.appVersion-----------------------")
    console.log(navigator.appVersion)
    if (navigator.appVersion.indexOf("Mac") >= 0) {
      if (navigator.appVersion.indexOf("Mobile") >= 0) {
        let osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2] + osVersion[3]);
        if (fullVersion > 12.10) {
          fullVersion = 13
        } else {
          fullVersion = 12
        }
      } else {
        let osVersion = /OS X (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
        // console.log("osVersion",osVersion)
        if(osVersion){
          fullVersion = parseFloat(osVersion[1] + '.' + osVersion[2]);
          if (fullVersion > 10.13) {
            fullVersion = 13
          } else {
            fullVersion = 12
          }
        } else {
          fullVersion = 12
        }
      }
    } else {
      fullVersion = 13;
    }
    return (
      <div className="backgroundColour" style={{
      background:  `url("${CarepetBackground}")`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover"}}>
        <this.ShareHeader loginStatus={loginStatus}/>

        {this.state.displayContent && this.state.gameNo !== '' ? <div className='  modalCssForShared'>
          {fullVersion && parseFloat(fullVersion) < 13 ? <HandReplayer
            replayerScreen={'shared'}
            isMultipleHands={this.state.isMultipleHands}
            selectedHandList={this.state.selectedHandList}
            selectedHandCount={this.state.selectedHandList.length}
            currentReplayerHandIndex={this.state.currentReplayerHandIndex}
            prevHand={this.prevHand}
            nextHand={this.nextHand}
            gameTypeForTitle={this.state.isMultipleHands ? this.state.selectedHandList[this.state.currentReplayerHandIndex].gameType : this.state.gameType}
            loginStatus={loginStatus}
            gameNo={this.state.isMultipleHands ? this.state.selectedHandList[this.state.currentReplayerHandIndex].gameNo : this.state.gameNo}
            playerAlias={this.state.playerAlias}
            partitionDate={this.state.isMultipleHands ? this.state.selectedHandList[this.state.currentReplayerHandIndex].fullDateTime : this.state.partitionDate}
            accountName={this.state.playerAlias}
            onClose={() => window.close()}
          /> :
            <ReplayHand
              sharedType={true}
              sharedId={this.state.sharedId}
              replayerScreen={'shared'}
              loginStatus={loginStatus}
              selectedHandList={this.state.selectedHandList}
              selectedHandCount={this.state.selectedHandList.length}
              currentReplayerHandIndex={this.state.currentReplayerHandIndex}
              isMultipleHands={this.state.isMultipleHands}
              prevHand={this.prevHand}
              nextHand={this.nextHand}
              openThisHand={this.openThisHand}
              gameNo={this.state.isMultipleHands ? this.state.selectedHandList[this.state.currentReplayerHandIndex].gameNo : this.state.gameNo}
              partitionDate={this.state.isMultipleHands ? this.state.selectedHandList[this.state.currentReplayerHandIndex].fullDateTime : this.state.partitionDate}
              accountName={localStorage.getItem('accountName')}
              gameTypeForTitle={this.state.isMultipleHands ? this.state.selectedHandList[this.state.currentReplayerHandIndex].gameType : this.state.gameType}
              onClose={() => window.close()}
              slideIndex={this.state.slideIndex}
              // i18next = {i18next}
            />}
        </div> : null}
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/HandReplayer/SharedReplayer.js
 **/